import { SVGProps } from "react";

/**
 * Myelina tree mark — minimal, hand-tuned SVG. Symmetric tree with roots,
 * canopy, and trunk. Designed to match the gold-leaf logo at small sizes.
 */
export const MyelinaMark = ({
  className,
  ...props
}: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 64 64"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    className={className}
    {...props}
  >
    <g stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
      {/* Trunk */}
      <path d="M32 50 V32" />
      {/* Main canopy boughs */}
      <path d="M32 32 C 24 28, 18 22, 16 14" />
      <path d="M32 32 C 40 28, 46 22, 48 14" />
      <path d="M32 32 C 30 24, 28 18, 26 12" />
      <path d="M32 32 C 34 24, 36 18, 38 12" />
      <path d="M32 32 C 32 22, 32 16, 32 10" />
      {/* Inner branches */}
      <path d="M22 22 L 19 18" />
      <path d="M42 22 L 45 18" />
      <path d="M28 18 L 26 14" />
      <path d="M36 18 L 38 14" />
      {/* Roots */}
      <path d="M32 50 C 26 52, 22 54, 18 56" />
      <path d="M32 50 C 38 52, 42 54, 46 56" />
      <path d="M32 50 V 58" />
      <path d="M28 53 L 24 58" />
      <path d="M36 53 L 40 58" />
      {/* Ground line — hairline */}
      <path d="M14 50 H 50" opacity="0.35" />
    </g>
  </svg>
);
